
export const DefaultHeaderImage = ({ headerImages }) => {
    const image = headerImages?.[0];
    if (!image) return null;
  return (
    <div className="relative h-[500px] w-full">
      <img
        className="block lg:hidden w-full absolute transform -rotate-[15deg] -right-10"
        src={image.imageUrl}
        alt={image.alt}
      />
    </div>
  );
};
